export const roundToTwoDecimal = (val = 0) => {
  return Math.round(val * 100) / 100;
};

// function that fixes a flot to x decimal places only if decimal exists
// eg (15.345657, 2) -> 15.34    (9, 3) -> 9
export const fixedToXDecialPlaces = (val, x = 2) => {
  return val.toFixed(x).replace(/\.00$/, "");
};
